module.exports = __webpack_public_path__ + "static/media/prev.c2058bb9.png";